<template>
  <div class="roles-main">
    <el-card class="box-card" shadow="never">
      <template #header>
        <div class="clearfix">
          <span class="role-span">{{ $t('menu.Settlement Report') }}</span>
        </div>
      </template>
      <el-tabs v-model="activeName">
        <el-tab-pane v-if="parseInt(store.state.user.siteId) !== 37" :label="t('fields.personalCommission')" name="personal">
          <PersonalSettlementTab />
        </el-tab-pane>
        <el-tab-pane v-if="parseInt(store.state.user.siteId) === 37" :label="t('fields.personalCommission')" name="my">
          <MySettlementTab />
        </el-tab-pane>
        <el-tab-pane v-if="parseInt(store.state.user.siteId) === 37" :label="t('fields.downlineCommission')" name="downline">
          <DownlineSettlementTab />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import PersonalSettlementTab from './tab/personal-settlement.vue'
import MySettlementTab from './tab/my-settlement.vue'
import DownlineSettlementTab from './tab/downline-settlement.vue'
import { useStore } from '@/store'
const { t } = useI18n()
const store = useStore()
const activeName = parseInt(store.state.user.siteId) === 37 ? ref('my') : ref('personal')
</script>
